module.exports = __webpack_public_path__ + "img/bed1.71b3b5da.svg";